import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DP_PRODUCT_CATEGORIES_FEATURE, ProductSubcategoriesState } from './product-subcategories-state.type';

const featureSelector = createFeatureSelector<ProductSubcategoriesState>(DP_PRODUCT_CATEGORIES_FEATURE);

export const categoriesSelector = createSelector(featureSelector, ({ categories }) => categories);
export const categoriesSwitcherSelector = createSelector(featureSelector, ({ switcher }) => switcher);
